<!-- Focus is moved in code: with <base href="/">, a bare #main link would navigate to "/#main". -->
<a class="bc-skip-link" href="#main" (click)="skipToMain($event)">Skip to main content</a>
<app-header></app-header>
<!-- A div, not <main>: several screens render their own <main>. -->
<div id="main" tabindex="-1">
  <router-outlet/>
</div>
